export default __webpack_public_path__ + "static/media/DOCUMENTO_ICONA_PDF.87c8c31c.svg";